var _rect, _rect2, _rect3, _rect4, _path, _path2, _g, _g2, _g3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyReportLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 266,
    height: 223,
    viewBox: "0 0 266 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 73,
    width: 58,
    height: 50,
    rx: 4,
    fill: "#EDF0FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 43,
    y: 23,
    width: 169,
    height: 42,
    rx: 4,
    fill: "#EDF0FF"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 120,
    y: 128,
    width: 105,
    height: 59,
    rx: 4,
    fill: "#EDF0FF"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 43.0029,
    y: 123,
    width: 71,
    height: 64,
    rx: 4,
    fill: "#EDF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M97.0029 160C97.0029 169.941 88.9441 178 79.0029 178C69.0618 178 61.0029 169.941 61.0029 160C61.0029 150.059 69.0618 142 79.0029 142C88.9441 142 97.0029 150.059 97.0029 160ZM67.2038 160C67.2038 166.516 72.4864 171.799 79.0029 171.799C85.5194 171.799 90.8021 166.516 90.8021 160C90.8021 153.484 85.5194 148.201 79.0029 148.201C72.4864 148.201 67.2038 153.484 67.2038 160Z",
    fill: "#3B57E9",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M79.0029 142C75.7994 142 72.6539 142.855 69.8912 144.477C67.1284 146.098 64.8485 148.428 63.2868 151.225C61.725 154.022 60.9381 157.185 61.0071 160.388C61.0762 163.591 61.9987 166.717 63.6795 169.444C65.3604 172.171 67.7386 174.401 70.5686 175.902C73.3987 177.403 76.5781 178.121 79.7787 177.983C82.9792 177.845 86.085 176.855 88.7753 175.116C91.4656 173.377 93.6429 170.951 95.0827 168.09L89.5433 165.303C88.5996 167.179 87.1723 168.769 85.4088 169.909C83.6453 171.049 81.6094 171.698 79.5114 171.788C77.4135 171.879 75.3293 171.408 73.4742 170.424C71.619 169.44 70.0601 167.978 68.9583 166.191C67.8565 164.403 67.2518 162.354 67.2065 160.254C67.1613 158.155 67.6771 156.081 68.7008 154.248C69.7246 152.414 71.2191 150.887 73.0301 149.824C74.8411 148.761 76.903 148.201 79.0029 148.201V142Z",
    fill: "#3B57E9",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_904_684)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 14.0029,
    y: 47,
    width: 150,
    height: 86,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.0029,
    y: 53,
    width: 138,
    height: 74,
    rx: 2.89655,
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_904_684)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M58.0993 101.476C34.9449 101.476 23.6693 118.718 20.9951 130.788H160.386V68.7129C149.355 77.3347 145.545 76.8174 134.313 74.7481C120.274 72.1616 110.156 99.7705 94.2006 103.2C82.1668 105.787 75.1471 101.476 58.0993 101.476Z",
    fill: "#3B57E9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M94.2112 88.5368C83.1802 94.5725 74.2775 107.506 57.1071 107.506C39.9366 107.506 20.0029 98.8842 20.0029 98.8842V130.785H160.397V97.1584C149.287 102.906 145.355 97.1576 134.324 91.1245C119.07 82.7821 105.775 82.2097 94.2112 88.5368Z",
    fill: "#3B57E9",
    fillOpacity: 0.2
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_904_684)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 163,
    y: 119,
    width: 76,
    height: 76,
    rx: 38,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 169,
    y: 125,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.5 155.5V146.5H202.5V155.5H211.5V158.5H202.5V167.5H199.5V158.5H190.5V155.5H199.5Z",
    fill: "#4E6AFF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_dd_904_684)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183,
    y: 35,
    width: 71,
    height: 58,
    rx: 6,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 41,
    width: 59,
    height: 46,
    rx: 2.8125,
    fill: "#EDF0FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 66,
    width: 44,
    height: 13,
    rx: 2.8125,
    fill: "#3B57E9",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 196,
    y: 48,
    width: 13,
    height: 13,
    rx: 2.8125,
    fill: "#3B57E9",
    fillOpacity: 0.2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_904_684",
    x: 0.739773,
    y: 42.5789,
    width: 176.526,
    height: 112.526,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.552632
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_904_684"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.8421
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.63158
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_904_684",
    result: "effect2_dropShadow_904_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_904_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_904_684",
    x: 145,
    y: 111,
    width: 112,
    height: 112,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_904_684"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 9
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_904_684",
    result: "effect2_dropShadow_904_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_904_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_dd_904_684",
    x: 171,
    y: 31,
    width: 95,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_904_684"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_904_684",
    result: "effect2_dropShadow_904_684"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_904_684",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_904_684"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 20.0029,
    y: 53,
    width: 138,
    height: 74,
    rx: 2.95084,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyReportLight);
export default __webpack_public_path__ + "static/media/empty-report-light.95d5f03a1cdcd26ae73feb6dfe373769.svg";
export { ForwardRef as ReactComponent };